<template>
  <b-modal
    :visible="isBlockModalActive"
    size="xl"
    hide-footer
    no-close-on-backdrop
    @change="(val) => $emit('update:is-block-modal-active', val)"
    @shown="getData(contentData)"
  >
    <template #modal-title>
      Block
    </template>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        class="p-2"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="types"
            rules="required"
          >
            <b-form-group label="Type" label-for="types">
              <v-select
                v-model="Data.types"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(option) => option.value"
                :options="OptionsTypes"
                :clearable="false"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="col"
            rules="min:1"
          >
            <b-form-group label="Size (columns) :" label-for="col">
              <b-form-spinbutton
                v-model="Data.col"
                min="1"
                max="12"
              ></b-form-spinbutton>
            </b-form-group>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
      </b-row>
      <b-tabs v-model="tabIndex">
        <b-form-group label-for="title">
          <b-tabs content-class="mt-1" v-if="langs.length > 0">
            <b-tab
              v-for="(lang, key) in langs || []"
              :key="'tab-' + key"
              :title="lang.name"
            >
              <validation-provider
                #default="validationContext"
                :name="'title_' + lang.code"
                rules="min:0"
              >
                <b-form-group label="Title" :label-for="'title_' + lang.code">
                  <b-form-input
                    :id="'title_' + lang.code"
                    v-model="Data.title[lang.code]"
                    autofocus
                    :state="getValidationState(validationContext)"
                    trim
                    :placeholder="'Title (' + lang.code + ')'"
                    @change="changeTitle(lang.code)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
              <validation-provider
                v-if="Data.types == 'content'"
                #default="validationContext"
                :name="'content_' + lang.code"
                rules="min:0"
              >
                <b-form-group
                  label="Content"
                  :label-for="'content_' + lang.code"
                >
                  <quill-editor :options="editorOptions" v-model="Data.content[lang.code]" />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-tab>
          </b-tabs>
        </b-form-group>
      </b-tabs>
        <div class="border rounded p-2" v-if="Data.types == 'image'">
          <h4 class="mb-1">Image</h4>
          <b-media
            no-body
            vertical-align="center"
            class="flex-column flex-md-row"
          >
            <b-media-aside>
              <b-img
                ref="refPreviewEl"
                :src="Data.image"
                height="110"
                width="170"
                class="rounded mr-2 mb-1 mb-md-0"
              />
            </b-media-aside>
            <b-media-body>
              <b-card-text class="my-50"> </b-card-text>
              <div class="d-inline-block">
                <b-form-file
                  ref="refInputEl"
                  v-model="Data.imgFile"
                  accept=".jpg, .png, .gif, .webp"
                  placeholder="Choose file"
                  @input="inputImageRenderer"
                />
              </div>

              <b-card-text class="my-50">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-if="Data.image"
                  @click="revomeImage"
                  >Remove Image</b-button
                >
              </b-card-text>
            </b-media-body>
          </b-media>
        </div>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            Submit
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide_form"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import {
  BForm,
  BButton,
  BFormInvalidFeedback,
  BFormGroup,
  BFormInput,
  BModal,
  VBModal,
  BFormSpinbutton,
  BMedia,
  BMediaAside,
  BMediaBody,
  BCardText,
  BAvatar,
  BImg,
  BLink,
  BFormFile,
  BRow,
  BCol,
  BTabs,
  BTab,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, password, confirmed } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import { slugify } from "@/@fake-db/utils";
import languagesStoreModule from "@/views/languages/languagesStoreModule";

import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";

import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";

export default {
  components: {
    BModal,
    BFormSpinbutton,
    ValidationProvider,
    ValidationObserver,
    BTabs,
    BTab,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BFormInvalidFeedback,
    vSelect,
    quillEditor,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BImg,
    BLink,
    BFormFile,
    BCardText,
    BRow,
    BCol,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  model: {
    prop: "isBlockModalActive",
    event: "update:is-block-modal-active",
  },
  props: {
    isBlockModalActive: {
      type: Boolean,
      required: true,
    },
    contentData: {
      type: Object,
      required: false,
    },
  },
  computed: {
    editorOptions (){
      return $themeConfig.snowOption
    }
  },

  setup(props, { emit }) {
    const {  appRef } = $themeConfig.app
    const toast = useToast();
    //UPload

    const tabIndex = ref(0);
    const langs = ref([]);
    const refInputEl = ref(null);
    const refPreviewEl = ref(null);

    const changeTitle = (lang) => {
      // console.log("SLUG", lang)

    };
    const refeshList = async () => {
      emit("refetch-data");
    };

    const getLangs = (fil) => {
      store.dispatch("app-languages/fetchData", fil).then((res) => {
        if (res.data.success) {
          langs.value = res.data.data;
        }
      });
    };
    let filter = {
      is_active: 1,
    };
    getLangs(filter);
    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );
    const OptionsTypes = ref([
      {
        value: "content",
        title: "Content",
      },
      {
        value: "image",
        title: "Image",
      },
    ]);
    const blankData = {
      id: "",
      types: "content",
      title: {},
      blog_id:"",
      content_id:"",
      content: {},
      image: "",
      col: 12,
    };
    const Data = ref(JSON.parse(JSON.stringify(blankData)));

    const getData = (data) => {
      data.imgFile = null;
      data.image_path = require("@/assets/images/no-image.png");
      if (data.image) {
        data.image_path = data.fullpath;
      }
      Data.value = data;

    };
    const revomeImage = () => {
      Data.value.image_path = require("@/assets/images/no-image.png");
      Data.value.image = "";
    };
    const resetData = () => {};
    const onSubmit = async () => {
      let formData = new FormData();
      Data.value.path = '/var/www/html/uploadfiles/uploads/'+appRef+'/blog/';
      Data.value.savepath = 'uploads/'+appRef+'/blog/';
      
      for (const [key, value] of Object.entries(Data.value)) {
        if (key == "title" || key == "content"){
          formData.append(key, JSON.stringify(value));
        }else{
          formData.append(key, value);
        }
      }

      // if(Data.value.types !== 'content'){
      //   formData.append('imgFile', refInputEl.value.files[0])
      // }

      formData.append('data', JSON.stringify(Data.value))

      if (Data.value.id) {
        let data = {
          formData: formData,
          id: Data.value.id,
        };
        const resp = await store.dispatch("blog-block/UpdateBlock", data);

        if (resp.data.success) {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "BellIcon",
              variant: "success",
              text: `${resp.data.message}`,
            },
          });
        } else {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "BellIcon",
              variant: "danger",
              text: `${resp.data.message}`,
            },
          });
        }
      } else {
        const resp = await store.dispatch("blog-block/addBlock", formData);
        if (resp.data.success) {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Success`,
              icon: "BellIcon",
              variant: "success",
              text: `${resp.data.message}`,
            },
          });
        } else {
          toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Error`,
              icon: "BellIcon",
              variant: "danger",
              text: `${resp.data.message}`,
            },
          });
        }
      }
      emit("update:is-block-modal-active", false);
      emit("refesh-block", Data.value.content_id);
    };
    const hide_form = () => {
      emit("update:is-block-modal-active", false);
    };
    const {
      refFormObserver,

      getValidationState,
      resetForm,
    } = formValidation(resetData);

    return {
      getData,
      refFormObserver,
      getValidationState,
      resetForm,
      onSubmit,
      hide_form,
      OptionsTypes,
      Data,
      refInputEl,
      refPreviewEl,
      inputImageRenderer,
      revomeImage,
      langs,
      changeTitle,
      refeshList,
      tabIndex
    };
  },
};
</script>
